import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { FileDownloadOutlined, Payment, WorkOutline } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { VendorStatement, VendorDetails } from "../../components/vendor";
import { PageHeader } from "../../components/v3";
import { ADD_VENDOR_PAYMENT, CREATE_PURCHASE, GENERATE_VENDOR_REPORT, VIEW_VENDOR_STATEMENT } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleVendor = () => {
  const [name, setName] = useState("");
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();

  const hasAddPurchase = useHasPermission(CREATE_PURCHASE);
  const hasAddPayment = useHasPermission(ADD_VENDOR_PAYMENT);
  const hasViewStatement = useHasPermission(VIEW_VENDOR_STATEMENT);
  const hasGenerateReport = useHasPermission(GENERATE_VENDOR_REPORT);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasAddPurchase && {
      buttonText: "Add Purchase",
      buttonIcon: WorkOutline,
      onClick: () => navigate(`/vendor/purchase/add?vendorId=${id}`),
    },
    hasAddPayment && {
      buttonText: "Add Payment",
      buttonIcon: Payment,
      onClick: () => navigate(`/transaction/add?vendorId=${id}`),
    },
    hasGenerateReport && {
      buttonText: "Download Report",
      buttonIcon: FileDownloadOutlined,
      onClick: () => navigate(`/reports/vendor?vendorId=${id}`),
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}></Box>
        <PageHeader
          // title
          title="Vendor Details"
          // button
          buttons={buttons}
        />

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <VendorDetails onSuccess={setName} reloadData={reload} />
        </Box>

        {/* purchase history */}
        {hasViewStatement && <VendorStatement name={name} onSuccess={handleReload} reloadData={reload} />}
      </PageLayout>
    </>
  );
};
